<template>
  <div class="block-tabell">
    <div class="block-tekst" v-html="content"></div>
  </div>
</template>
<script>
import Renderer from "./mixin";

export default {
  computed: {
    content() {
      if (this.$i18n.locale == "no") {
        return this.$md.render(this.Innhold);
      } else {
        return this.$md.render(this.Innhold_eng);
      }
    },
  },
  mixins: [Renderer(["Innhold", "Innhold_eng"])],
};
</script>

<style lang="scss">
.block-tabell {
  overflow-x: none;
  margin-bottom: 4em;
  max-width: 800px;

  table {
    margin-top: 1em;
    font-size: 0.8em;
    border-collapse: collapse;
    width: 100%;
    tr,
    td,
    th {
      font-weight: normal;
      padding: 0.65em;
      border: 1px solid #ccc;
      text-align: left;
    }
  }
}
</style>
